(function () {
    'use strict';

    angular.module('doclr.security', ['doclr.keycloak'])
        .factory('unauthorizedInterceptor', function ($q, $window) {
            return {
                responseError: function (response) {
                    if (response.status === 401) {
                        //              $window.location.href = '/login';
                    }
                    return $q.reject(response);
                }
            };
        }).directive('logout', function () {
        return {
            transclude: true,
            template: '<a ng-click="logout()" ng-transclude></a>',
            controller: function ($scope) {
                $scope.logout = function () {
                    window.keycloakServiceInstance.logout();
                };
            }
        };
    })
        .config(function ($httpProvider) {
            $httpProvider.interceptors.push('unauthorizedInterceptor');
        });
})();